"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BRANCH_LAST_ACTIVE () {
        return _brancherrors.BRANCH_LAST_ACTIVE;
    },
    get BRANCH_NAME_TAKEN () {
        return _brancherrors.BRANCH_NAME_TAKEN;
    },
    get BRANCH_VERSION_CONFLICT () {
        return _brancherrors.BRANCH_VERSION_CONFLICT;
    },
    get BranchCreateRequestSchema () {
        return _branch.BranchCreateRequestSchema;
    },
    get BranchListResponseSchema () {
        return _branch.BranchListResponseSchema;
    },
    get BranchSchema () {
        return _branch.BranchSchema;
    },
    get BranchStatusRequestSchema () {
        return _branch.BranchStatusRequestSchema;
    },
    get BranchUpdateRequestSchema () {
        return _branch.BranchUpdateRequestSchema;
    },
    get CLINIC_PHONE_PATTERN () {
        return _clinicprofile.CLINIC_PHONE_PATTERN;
    },
    get CLINIC_POSTAL_CODE_PATTERN () {
        return _clinicprofile.CLINIC_POSTAL_CODE_PATTERN;
    },
    get CLINIC_PROFILE_LIMITS () {
        return _clinicprofile.CLINIC_PROFILE_LIMITS;
    },
    get ClinicProfileSchema () {
        return _clinicprofile.ClinicProfileSchema;
    }
});
const _clinicprofile = require("./clinic-profile");
const _branch = require("./branch");
const _brancherrors = require("./branch-errors");
